// local
import { pending, rejected, fulfilled } from './async';
import * as Report from 'app/api/report';
import dispatchError from './error';

const ACTION_KEY = 'REPORT';

export function reset() {
    return {
        type: `${ACTION_KEY}_RESET`,
    };
}

export function generatePDF(method, query) {
    return dispatch => {
        dispatch(pending(`${ACTION_KEY}_PDF`));
        method(query)
            .then(() => dispatch(fulfilled(`${ACTION_KEY}_PDF`)))
            .catch(err => dispatch(rejected(`${ACTION_KEY}_PDF`, err)));
    };
}

function loadReport(method, query) {
    return dispatch => {
        dispatch(pending(ACTION_KEY));
        method(query)
            .then(payload => {
                dispatch(fulfilled(ACTION_KEY, { data: payload, query }));
            })
            .catch(err => {
                dispatch(rejected(ACTION_KEY, err));
                dispatchError(dispatch, err);
            });
    };
}

/* DOWNLOAD PDF METHODS */
export function downloadPDFByPatient(query) {
    return generatePDF(Report.reportByPatientExport, query);
}
export function downloadPDFBySupplier(query) {
    return generatePDF(Report.reportBySupplierExport, query);
}
export function downloadPDFByGeneral(query) {
    return generatePDF(Report.reportByGeneralExport, query);

}
export function downloadPDFChangesByPatient(query) {
    return generatePDF(Report.reportChangeByPatientExport, query);
}
export function downloadPDFChangesBySupplier(query) {
    return generatePDF(Report.reportChangeBySupplierExport, query);
}
export function downloadPDFChangesByGeneral(query) {
    return generatePDF(Report.reportChangesExport, query);
}
export function downloadPDFDaily(query) {
    return generatePDF(Report.reportDailyConsumptionExport, query);
}

/* LOAD METHODS */
export function loadReportByPatient(query) {
    return loadReport(Report.reportByPatient, query);
}
export function loadReportPrescription(query) {
    return loadReport(Report.reportPrescription, query);
}
export function loadReportDaily(query) {
    return loadReport(Report.reportDailyConsumption, query);
}
export function loadReportChangeByPatient(query) {
    return loadReport(Report.reportChangeByPatient, query);
}
export function loadReportChangeBySupplier(query) {
    return loadReport(Report.reportChangeBySupplier, query);
}
export function loadReportChanges(query) {
    return loadReport(Report.reportChanges, query);
}
export function loadReportBySupplier(query) {
    return loadReport(Report.reportBySupplier, query);
}
export function loadReportByGeneral(query) {
    return loadReport(Report.reportByGeneral, query);
}
